import { render, staticRenderFns } from "./DevicesView.vue?vue&type=template&id=9f60d45e&scoped=true&"
import script from "./DevicesView.vue?vue&type=script&lang=js&"
export * from "./DevicesView.vue?vue&type=script&lang=js&"
import style0 from "./DevicesView.vue?vue&type=style&index=0&id=9f60d45e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f60d45e",
  null
  
)

export default component.exports